import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getApiClient, initializeApiClient } from "../../../../Services/Api/ApiServices";

export const upload = createAsyncThunk(
  "upload/upload",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient("application/json");
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/UploadDownload/upload",
        parameters
      );

      const data = response.data; // Assuming response has a "data" field
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const CompressAttachments = createSlice({
  name: "CompressAttachments",
  initialState: {
    CompressAttachmentsUpload: {},
    loadingCompressAttachmentsUpload: false,
    errorCompressAttachmentsUpload: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(upload.pending, (state, action) => {
        state.loadingCompressAttachmentsUpload = true;
        state.CompressAttachmentsUpload = action.payload;
        state.errorCompressAttachmentsUpload = null;
      })
      .addCase(upload.fulfilled, (state, action) => {
        state.loadingCompressAttachmentsUpload = false;
        state.CompressAttachmentsUpload = action.payload; // Assuming payload has the desired data
      })
      .addCase(upload.rejected, (state, action) => {
        state.loadingCompressAttachmentsUpload = false;
        state.errorCompressAttachmentsUpload = action.payload;
      });
  },
});

export default CompressAttachments.reducer;
